module.exports = __webpack_public_path__ + "static/img/passo1.f3242f94.svg";